import styled from '@app/styled';
import { spacing } from '@app/theme';

export const PageContainer = styled.div`
    height: 100%;
    padding: ${spacing(0, 7)};
`;
